/* eslint-disable */
import { Timestamp } from "../../google/protobuf/timestamp";
import {
  App_Platform,
  app_PlatformFromJSON,
  app_PlatformToJSON,
  InvoiceUniform,
  invoiceUniformFromJSON,
  invoiceUniformToJSON,
  Recipient,
} from "../common/common";
import {
  Customer_Provider,
  customer_ProviderFromJSON,
  customer_ProviderToJSON,
  Customer_State,
  customer_StateFromJSON,
  customer_StateToJSON,
} from "../customers/resources";

export const protobufPackage = "api.orders";

export interface SalesOrder {
  /** 訂單編號 */
  id: string;
  /** 訂單狀態 */
  state: SalesOrder_State;
  /** 訂單成立時間 */
  createTime:
    | Date
    | undefined;
  /** 訂單成立平台 */
  platform: App_Platform;
  /** 付款類型, valid only when `state` is not UNPAID. */
  paymentType: SalesOrder_PaymentType;
  /** 授權時間 */
  authorizationTime:
    | Date
    | undefined;
  /**
   * 數量加總/商品數量
   * Sum of all `Item.quantity`.
   */
  quantity: number;
  /**
   * 小計加總/商品總價
   * Sum of all `Item.subtotal`.
   */
  subtotal: string;
  /** 物流運費 */
  shipping: string;
  /** 虛帳抵扣 */
  balanceDeduction: string;
  /** 活動折抵金額 */
  promotionDeduction: string;
  /** 合計/請款金額 = 小計加總 - 折價券折抵金額 - 活動折抵金額 + 物流費 */
  total: string;
  /** 配送物流 */
  logisticsCompany: SalesOrder_LogisticsCompany;
  /** 發票資訊 */
  receipt:
    | Receipt
    | undefined;
  /** 是否已刪除 */
  deleted: boolean;
  /** 收件人資訊 */
  recipient:
    | Recipient
    | undefined;
  /** 訂單品項. Order by `sku_id` ASC */
  items: SalesOrder_Item[];
  /** 會員編號 */
  customerId: string;
  /** 會員編號 */
  customerFriendlyId: string;
  /** 會員暱稱 */
  customerName: string;
  /** 會員狀態 */
  customerState: Customer_State;
  /** 帳號類型 */
  customerProvider: Customer_Provider;
  /** 會員註冊時間 */
  customerCreateTime:
    | Date
    | undefined;
  /** 信用卡號末四碼 */
  creditCardSuffix: string;
  /** 美金兌換台幣匯率 */
  exchangeRateUsdNtd: string;
  /** 退貨聲明 */
  returnDeclaration: boolean;
  /** 運費門檻 */
  shippingThreshold: string;
  /** 未完成授權系統取消 */
  unpaidCanceled: boolean;
  /** 訂單取消時間 */
  cancelTime:
    | Date
    | undefined;
  /** 計價重量 */
  chargeableWeight: string;
  /** 離線訊息id */
  onlineSessionId: string;
  /** 廣告參數 */
  adId: string;
  /** 付款狀態 */
  paymentState: number;
  /** 成立訂單當下未滿免運門檻的物流運費 */
  shippingFeeSnapshot: string;
}

/** 狀態 */
export enum SalesOrder_State {
  STATE_UNSPECIFIED = 0,
  /** STATE_WAIT_BUYER_PAY - 等待買家付款, 未完成授權 */
  STATE_WAIT_BUYER_PAY = 1,
  /** STATE_WAIT_SELLER_SEND_GOODS - 等待賣家發貨, 完成付款成立訂單 */
  STATE_WAIT_SELLER_SEND_GOODS = 2,
  /** STATE_WAIT_SELLER_PROCESSING - 賣家處理中 */
  STATE_WAIT_SELLER_PROCESSING = 3,
  /** STATE_WAIT_BUYER_CONFIRM_GOODS - 等待買家確認收貨,即：賣家已發貨，包裹配送中 */
  STATE_WAIT_BUYER_CONFIRM_GOODS = 4,
  /** STATE_OUTFLOW_ERROR - 訂單包裹配送異常 */
  STATE_OUTFLOW_ERROR = 5,
  /** STATE_DELIVERED - 包裹已送達，例：非宅配包裹已送達至取貨地點 */
  STATE_DELIVERED = 6,
  /** STATE_BUYER_SIGNED - 已簽收/已取貨 */
  STATE_BUYER_SIGNED = 7,
  /** STATE_CANCELED - 取消 */
  STATE_CANCELED = 8,
}

export function salesOrder_StateFromJSON(object: any): SalesOrder_State {
  switch (object) {
    case 0:
    case "STATE_UNSPECIFIED":
      return SalesOrder_State.STATE_UNSPECIFIED;
    case 1:
    case "STATE_WAIT_BUYER_PAY":
      return SalesOrder_State.STATE_WAIT_BUYER_PAY;
    case 2:
    case "STATE_WAIT_SELLER_SEND_GOODS":
      return SalesOrder_State.STATE_WAIT_SELLER_SEND_GOODS;
    case 3:
    case "STATE_WAIT_SELLER_PROCESSING":
      return SalesOrder_State.STATE_WAIT_SELLER_PROCESSING;
    case 4:
    case "STATE_WAIT_BUYER_CONFIRM_GOODS":
      return SalesOrder_State.STATE_WAIT_BUYER_CONFIRM_GOODS;
    case 5:
    case "STATE_OUTFLOW_ERROR":
      return SalesOrder_State.STATE_OUTFLOW_ERROR;
    case 6:
    case "STATE_DELIVERED":
      return SalesOrder_State.STATE_DELIVERED;
    case 7:
    case "STATE_BUYER_SIGNED":
      return SalesOrder_State.STATE_BUYER_SIGNED;
    case 8:
    case "STATE_CANCELED":
      return SalesOrder_State.STATE_CANCELED;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_State");
  }
}

export function salesOrder_StateToJSON(object: SalesOrder_State): string {
  switch (object) {
    case SalesOrder_State.STATE_UNSPECIFIED:
      return "STATE_UNSPECIFIED";
    case SalesOrder_State.STATE_WAIT_BUYER_PAY:
      return "STATE_WAIT_BUYER_PAY";
    case SalesOrder_State.STATE_WAIT_SELLER_SEND_GOODS:
      return "STATE_WAIT_SELLER_SEND_GOODS";
    case SalesOrder_State.STATE_WAIT_SELLER_PROCESSING:
      return "STATE_WAIT_SELLER_PROCESSING";
    case SalesOrder_State.STATE_WAIT_BUYER_CONFIRM_GOODS:
      return "STATE_WAIT_BUYER_CONFIRM_GOODS";
    case SalesOrder_State.STATE_OUTFLOW_ERROR:
      return "STATE_OUTFLOW_ERROR";
    case SalesOrder_State.STATE_DELIVERED:
      return "STATE_DELIVERED";
    case SalesOrder_State.STATE_BUYER_SIGNED:
      return "STATE_BUYER_SIGNED";
    case SalesOrder_State.STATE_CANCELED:
      return "STATE_CANCELED";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_State");
  }
}

/** 付款類型 */
export enum SalesOrder_PaymentType {
  PAYMENT_TYPE_UNSPECIFIED = 0,
  /**
   * PAYMENT_TYPE_SEVEN_ELEVEN - 超商
   *
   * 7-11 取貨付款
   */
  PAYMENT_TYPE_SEVEN_ELEVEN = 1,
  /** PAYMENT_TYPE_FAMILY_MART - 全家 取貨付款 */
  PAYMENT_TYPE_FAMILY_MART = 2,
  /**
   * PAYMENT_TYPE_CREDIT_CARD - 信用卡
   *
   * 信用卡-玉山
   */
  PAYMENT_TYPE_CREDIT_CARD = 11,
  /** PAYMENT_TYPE_CREDIT_CARD_CTBC - 信用卡-中信 */
  PAYMENT_TYPE_CREDIT_CARD_CTBC = 12,
  /**
   * PAYMENT_TYPE_LINE_PAY - 電子支付
   *
   * Line Pay
   */
  PAYMENT_TYPE_LINE_PAY = 21,
  /** PAYMENT_TYPE_APPLE_PAY - Apple Pay */
  PAYMENT_TYPE_APPLE_PAY = 22,
  /**
   * PAYMENT_TYPE_CASH_ON_DELIVERY - 其他
   *
   * 宅配 貨到付款
   */
  PAYMENT_TYPE_CASH_ON_DELIVERY = 31,
  /** PAYMENT_TYPE_OVERSEA - 海外配送-玉山 */
  PAYMENT_TYPE_OVERSEA = 32,
  /** PAYMENT_TYPE_OVERSEA_CTBC - 海外配送-中信 */
  PAYMENT_TYPE_OVERSEA_CTBC = 33,
}

export function salesOrder_PaymentTypeFromJSON(object: any): SalesOrder_PaymentType {
  switch (object) {
    case 0:
    case "PAYMENT_TYPE_UNSPECIFIED":
      return SalesOrder_PaymentType.PAYMENT_TYPE_UNSPECIFIED;
    case 1:
    case "PAYMENT_TYPE_SEVEN_ELEVEN":
      return SalesOrder_PaymentType.PAYMENT_TYPE_SEVEN_ELEVEN;
    case 2:
    case "PAYMENT_TYPE_FAMILY_MART":
      return SalesOrder_PaymentType.PAYMENT_TYPE_FAMILY_MART;
    case 11:
    case "PAYMENT_TYPE_CREDIT_CARD":
      return SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD;
    case 12:
    case "PAYMENT_TYPE_CREDIT_CARD_CTBC":
      return SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD_CTBC;
    case 21:
    case "PAYMENT_TYPE_LINE_PAY":
      return SalesOrder_PaymentType.PAYMENT_TYPE_LINE_PAY;
    case 22:
    case "PAYMENT_TYPE_APPLE_PAY":
      return SalesOrder_PaymentType.PAYMENT_TYPE_APPLE_PAY;
    case 31:
    case "PAYMENT_TYPE_CASH_ON_DELIVERY":
      return SalesOrder_PaymentType.PAYMENT_TYPE_CASH_ON_DELIVERY;
    case 32:
    case "PAYMENT_TYPE_OVERSEA":
      return SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA;
    case 33:
    case "PAYMENT_TYPE_OVERSEA_CTBC":
      return SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA_CTBC;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_PaymentType");
  }
}

export function salesOrder_PaymentTypeToJSON(object: SalesOrder_PaymentType): string {
  switch (object) {
    case SalesOrder_PaymentType.PAYMENT_TYPE_UNSPECIFIED:
      return "PAYMENT_TYPE_UNSPECIFIED";
    case SalesOrder_PaymentType.PAYMENT_TYPE_SEVEN_ELEVEN:
      return "PAYMENT_TYPE_SEVEN_ELEVEN";
    case SalesOrder_PaymentType.PAYMENT_TYPE_FAMILY_MART:
      return "PAYMENT_TYPE_FAMILY_MART";
    case SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD:
      return "PAYMENT_TYPE_CREDIT_CARD";
    case SalesOrder_PaymentType.PAYMENT_TYPE_CREDIT_CARD_CTBC:
      return "PAYMENT_TYPE_CREDIT_CARD_CTBC";
    case SalesOrder_PaymentType.PAYMENT_TYPE_LINE_PAY:
      return "PAYMENT_TYPE_LINE_PAY";
    case SalesOrder_PaymentType.PAYMENT_TYPE_APPLE_PAY:
      return "PAYMENT_TYPE_APPLE_PAY";
    case SalesOrder_PaymentType.PAYMENT_TYPE_CASH_ON_DELIVERY:
      return "PAYMENT_TYPE_CASH_ON_DELIVERY";
    case SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA:
      return "PAYMENT_TYPE_OVERSEA";
    case SalesOrder_PaymentType.PAYMENT_TYPE_OVERSEA_CTBC:
      return "PAYMENT_TYPE_OVERSEA_CTBC";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_PaymentType");
  }
}

/** 運送類型 */
export enum SalesOrder_DeliveryType {
  /** DELIVERY_TYPE_UNSPECIFIED - 視為 ALL: 店配＋宅配＋海外(PAYMENT_TYPE_OVERSEA) */
  DELIVERY_TYPE_UNSPECIFIED = 0,
  /**
   * DELIVERY_TYPE_PICKUP_STORE - 店配
   * PAYMENT_TYPE_SEVEN_ELEVEN
   * PAYMENT_TYPE_FAMILY_MART
   */
  DELIVERY_TYPE_PICKUP_STORE = 1,
  /**
   * DELIVERY_TYPE_HOME - 宅配
   * PAYMENT_TYPE_CREDIT_CARD
   * PAYMENT_TYPE_LINE_PAY
   * PAYMENT_TYPE_CASH_ON_DELIVERY
   * PAYMENT_TYPE_APPLE_PAY
   * PAYMENT_TYPE_OVERSEA
   */
  DELIVERY_TYPE_HOME = 2,
  /**
   * DELIVERY_TYPE_OVERSEA - 海外
   * PAYMENT_TYPE_OVERSEA
   */
  DELIVERY_TYPE_OVERSEA = 3,
}

export function salesOrder_DeliveryTypeFromJSON(object: any): SalesOrder_DeliveryType {
  switch (object) {
    case 0:
    case "DELIVERY_TYPE_UNSPECIFIED":
      return SalesOrder_DeliveryType.DELIVERY_TYPE_UNSPECIFIED;
    case 1:
    case "DELIVERY_TYPE_PICKUP_STORE":
      return SalesOrder_DeliveryType.DELIVERY_TYPE_PICKUP_STORE;
    case 2:
    case "DELIVERY_TYPE_HOME":
      return SalesOrder_DeliveryType.DELIVERY_TYPE_HOME;
    case 3:
    case "DELIVERY_TYPE_OVERSEA":
      return SalesOrder_DeliveryType.DELIVERY_TYPE_OVERSEA;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_DeliveryType");
  }
}

export function salesOrder_DeliveryTypeToJSON(object: SalesOrder_DeliveryType): string {
  switch (object) {
    case SalesOrder_DeliveryType.DELIVERY_TYPE_UNSPECIFIED:
      return "DELIVERY_TYPE_UNSPECIFIED";
    case SalesOrder_DeliveryType.DELIVERY_TYPE_PICKUP_STORE:
      return "DELIVERY_TYPE_PICKUP_STORE";
    case SalesOrder_DeliveryType.DELIVERY_TYPE_HOME:
      return "DELIVERY_TYPE_HOME";
    case SalesOrder_DeliveryType.DELIVERY_TYPE_OVERSEA:
      return "DELIVERY_TYPE_OVERSEA";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_DeliveryType");
  }
}

/** 發票處理方式 */
export enum SalesOrder_ReceiptMethod {
  RECEIPT_METHOD_UNSPECIFIED = 0,
  /** RECEIPT_METHOD_MEMBER_CARRIER - 會員載具 */
  RECEIPT_METHOD_MEMBER_CARRIER = 1,
  /** RECEIPT_METHOD_MOBILE_BARCODE - 手機條碼 */
  RECEIPT_METHOD_MOBILE_BARCODE = 2,
  /** RECEIPT_METHOD_TAX_ID_NUMBER - 統一編號 */
  RECEIPT_METHOD_TAX_ID_NUMBER = 3,
  /** RECEIPT_METHOD_DONATION_CODE - 捐贈碼 */
  RECEIPT_METHOD_DONATION_CODE = 4,
  /** RECEIPT_METHOD_PAPER - 紙本發票 - 個人 */
  RECEIPT_METHOD_PAPER = 5,
}

export function salesOrder_ReceiptMethodFromJSON(object: any): SalesOrder_ReceiptMethod {
  switch (object) {
    case 0:
    case "RECEIPT_METHOD_UNSPECIFIED":
      return SalesOrder_ReceiptMethod.RECEIPT_METHOD_UNSPECIFIED;
    case 1:
    case "RECEIPT_METHOD_MEMBER_CARRIER":
      return SalesOrder_ReceiptMethod.RECEIPT_METHOD_MEMBER_CARRIER;
    case 2:
    case "RECEIPT_METHOD_MOBILE_BARCODE":
      return SalesOrder_ReceiptMethod.RECEIPT_METHOD_MOBILE_BARCODE;
    case 3:
    case "RECEIPT_METHOD_TAX_ID_NUMBER":
      return SalesOrder_ReceiptMethod.RECEIPT_METHOD_TAX_ID_NUMBER;
    case 4:
    case "RECEIPT_METHOD_DONATION_CODE":
      return SalesOrder_ReceiptMethod.RECEIPT_METHOD_DONATION_CODE;
    case 5:
    case "RECEIPT_METHOD_PAPER":
      return SalesOrder_ReceiptMethod.RECEIPT_METHOD_PAPER;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_ReceiptMethod");
  }
}

export function salesOrder_ReceiptMethodToJSON(object: SalesOrder_ReceiptMethod): string {
  switch (object) {
    case SalesOrder_ReceiptMethod.RECEIPT_METHOD_UNSPECIFIED:
      return "RECEIPT_METHOD_UNSPECIFIED";
    case SalesOrder_ReceiptMethod.RECEIPT_METHOD_MEMBER_CARRIER:
      return "RECEIPT_METHOD_MEMBER_CARRIER";
    case SalesOrder_ReceiptMethod.RECEIPT_METHOD_MOBILE_BARCODE:
      return "RECEIPT_METHOD_MOBILE_BARCODE";
    case SalesOrder_ReceiptMethod.RECEIPT_METHOD_TAX_ID_NUMBER:
      return "RECEIPT_METHOD_TAX_ID_NUMBER";
    case SalesOrder_ReceiptMethod.RECEIPT_METHOD_DONATION_CODE:
      return "RECEIPT_METHOD_DONATION_CODE";
    case SalesOrder_ReceiptMethod.RECEIPT_METHOD_PAPER:
      return "RECEIPT_METHOD_PAPER";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_ReceiptMethod");
  }
}

/** 配送物流 */
export enum SalesOrder_LogisticsCompany {
  LOGISTICS_COMPANY_UNSPECIFIED = 0,
  /** LOGISTICS_COMPANY_SEVEN_ELEVEN - 7-11 */
  LOGISTICS_COMPANY_SEVEN_ELEVEN = 1,
  /** LOGISTICS_COMPANY_FAMILY - 全家 */
  LOGISTICS_COMPANY_FAMILY = 2,
  /** LOGISTICS_COMPANY_TCAT - 黑貓宅急便 */
  LOGISTICS_COMPANY_TCAT = 3,
  /** LOGISTICS_COMPANY_SF - 順豐 */
  LOGISTICS_COMPANY_SF = 4,
  /** LOGISTICS_COMPANY_CHPYTWTP - 中華郵政 */
  LOGISTICS_COMPANY_CHPYTWTP = 5,
  /** LOGISTICS_COMPANY_UCF - 華美航運 */
  LOGISTICS_COMPANY_UCF = 6,
}

export function salesOrder_LogisticsCompanyFromJSON(object: any): SalesOrder_LogisticsCompany {
  switch (object) {
    case 0:
    case "LOGISTICS_COMPANY_UNSPECIFIED":
      return SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_UNSPECIFIED;
    case 1:
    case "LOGISTICS_COMPANY_SEVEN_ELEVEN":
      return SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_SEVEN_ELEVEN;
    case 2:
    case "LOGISTICS_COMPANY_FAMILY":
      return SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_FAMILY;
    case 3:
    case "LOGISTICS_COMPANY_TCAT":
      return SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_TCAT;
    case 4:
    case "LOGISTICS_COMPANY_SF":
      return SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_SF;
    case 5:
    case "LOGISTICS_COMPANY_CHPYTWTP":
      return SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_CHPYTWTP;
    case 6:
    case "LOGISTICS_COMPANY_UCF":
      return SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_UCF;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_LogisticsCompany");
  }
}

export function salesOrder_LogisticsCompanyToJSON(object: SalesOrder_LogisticsCompany): string {
  switch (object) {
    case SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_UNSPECIFIED:
      return "LOGISTICS_COMPANY_UNSPECIFIED";
    case SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_SEVEN_ELEVEN:
      return "LOGISTICS_COMPANY_SEVEN_ELEVEN";
    case SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_FAMILY:
      return "LOGISTICS_COMPANY_FAMILY";
    case SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_TCAT:
      return "LOGISTICS_COMPANY_TCAT";
    case SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_SF:
      return "LOGISTICS_COMPANY_SF";
    case SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_CHPYTWTP:
      return "LOGISTICS_COMPANY_CHPYTWTP";
    case SalesOrder_LogisticsCompany.LOGISTICS_COMPANY_UCF:
      return "LOGISTICS_COMPANY_UCF";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_LogisticsCompany");
  }
}

/** 訂單記錄 */
export interface SalesOrder_Note {
}

/** 來源 */
export enum SalesOrder_Note_Source {
  SOURCE_UNSPECIFIED = 0,
  /** SOURCE_SYSTEM - 系統 */
  SOURCE_SYSTEM = 1,
  /** SOURCE_ORDER - 訂單 */
  SOURCE_ORDER = 2,
  /** SOURCE_ONLINE - 線上 */
  SOURCE_ONLINE = 3,
  /** SOURCE_INCALL - 來電 */
  SOURCE_INCALL = 4,
  /** SOURCE_OUTCALL - 去電 */
  SOURCE_OUTCALL = 5,
}

export function salesOrder_Note_SourceFromJSON(object: any): SalesOrder_Note_Source {
  switch (object) {
    case 0:
    case "SOURCE_UNSPECIFIED":
      return SalesOrder_Note_Source.SOURCE_UNSPECIFIED;
    case 1:
    case "SOURCE_SYSTEM":
      return SalesOrder_Note_Source.SOURCE_SYSTEM;
    case 2:
    case "SOURCE_ORDER":
      return SalesOrder_Note_Source.SOURCE_ORDER;
    case 3:
    case "SOURCE_ONLINE":
      return SalesOrder_Note_Source.SOURCE_ONLINE;
    case 4:
    case "SOURCE_INCALL":
      return SalesOrder_Note_Source.SOURCE_INCALL;
    case 5:
    case "SOURCE_OUTCALL":
      return SalesOrder_Note_Source.SOURCE_OUTCALL;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_Note_Source");
  }
}

export function salesOrder_Note_SourceToJSON(object: SalesOrder_Note_Source): string {
  switch (object) {
    case SalesOrder_Note_Source.SOURCE_UNSPECIFIED:
      return "SOURCE_UNSPECIFIED";
    case SalesOrder_Note_Source.SOURCE_SYSTEM:
      return "SOURCE_SYSTEM";
    case SalesOrder_Note_Source.SOURCE_ORDER:
      return "SOURCE_ORDER";
    case SalesOrder_Note_Source.SOURCE_ONLINE:
      return "SOURCE_ONLINE";
    case SalesOrder_Note_Source.SOURCE_INCALL:
      return "SOURCE_INCALL";
    case SalesOrder_Note_Source.SOURCE_OUTCALL:
      return "SOURCE_OUTCALL";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesOrder_Note_Source");
  }
}

/**
 * 訂單品項
 * Every item is uniquely identified by the `Item.id`.
 * When displayed as a collection, the items should be sorted by `sku_id` ASC.
 */
export interface SalesOrder_Item {
  /** Unique id generated by the server for this `Item`, not visible to customers */
  id: string;
  /** 商品編號 */
  skuId: string;
  /** 商品名稱 */
  productName: string;
  /** 商品圖片. Image 360 pixels. */
  productImage: string;
  /** 顏色 */
  colorName: string;
  /** 尺寸 */
  sizeName: string;
  /** 尺碼後綴 */
  sizeSuffix: string;
  /** 單價 */
  unitPrice: string;
  /** 折扣後單價 */
  discountedUnitPrice: string;
  /** 活動名稱 */
  promotionId: string;
  /** 活動名稱 */
  promotionName: string;
  /** 活動攤提折扣 */
  promotionAmortizedDeduction: string;
  /** 購買數量 */
  quantity: number;
  /** 小計加總 */
  subtotal: string;
  /** 商品單價小計 */
  unitPriceSubtotal: string;
  /** 訂單品項成立時間 */
  createTime:
    | Date
    | undefined;
  /** 是否符合活動 */
  promotionQualified: boolean;
}

export interface SalesReturn {
  /** 退單編號. Unique id generated by the server. */
  id: string;
  /** 訂單編號. Visible in the UI for customers. */
  orderId: string;
  /** 退單前端顯示狀態 */
  state: SalesReturn_State;
  /** 退單成立平台 */
  platform: App_Platform;
  /** 退單成立時間 */
  createTime:
    | Date
    | undefined;
  /** 退單成立時間 */
  updateTime:
    | Date
    | undefined;
  /** 付款類型 */
  paymentType: SalesOrder_PaymentType;
  /** 退貨明細 */
  items: SalesReturn_Item[];
  /** 退貨商品數量加總 */
  totalQuantity: number;
  /** 退貨商品金額加總 */
  total: string;
  /** 退款總金額 */
  refundAmount: string;
  /** 寄回物流公司 */
  returnChannel: SalesReturn_ReturnChannel;
  /** 寄回物流編號 */
  shipmentTrackingNumber: string;
  /** 退貨驗證碼 */
  shipmentValidationNo: string;
  /** 退款渠道 */
  refundChannel: SalesReturn_RefundChannel;
  /** 寄件人姓名 */
  senderName: string;
  /** 寄件人城市 */
  senderCity: string;
  /** 寄件人鄉鎮市區 */
  senderArea: string;
  /** 寄件人地址 */
  senderStreet: string;
  /** 寄件人郵遞區號 */
  senderPostcode: string;
  /** 已上傳寄件人電話 */
  phoneUploaded: boolean;
}

/** 狀態 */
export enum SalesReturn_State {
  STATUS_UNKNOWN = 0,
  /** WAIT_BUYER_RETURN_GOODS - 賣家已經同意退款，等待買家退貨 */
  WAIT_BUYER_RETURN_GOODS = 1,
  /** WAIT_SELLER_CONFIRM_GOODS - 買家已經退貨，等待賣家確認收貨 */
  WAIT_SELLER_CONFIRM_GOODS = 2,
  /** SELLER_CONFIRMING_GOODS - 賣家確認收貨 */
  SELLER_CONFIRMING_GOODS = 3,
  /** PENDING_REFUND - 待退款 */
  PENDING_REFUND = 4,
  /** SUCCESS - 退款成功 */
  SUCCESS = 5,
  /** CLOSED - 退款關閉 */
  CLOSED = 6,
}

export function salesReturn_StateFromJSON(object: any): SalesReturn_State {
  switch (object) {
    case 0:
    case "STATUS_UNKNOWN":
      return SalesReturn_State.STATUS_UNKNOWN;
    case 1:
    case "WAIT_BUYER_RETURN_GOODS":
      return SalesReturn_State.WAIT_BUYER_RETURN_GOODS;
    case 2:
    case "WAIT_SELLER_CONFIRM_GOODS":
      return SalesReturn_State.WAIT_SELLER_CONFIRM_GOODS;
    case 3:
    case "SELLER_CONFIRMING_GOODS":
      return SalesReturn_State.SELLER_CONFIRMING_GOODS;
    case 4:
    case "PENDING_REFUND":
      return SalesReturn_State.PENDING_REFUND;
    case 5:
    case "SUCCESS":
      return SalesReturn_State.SUCCESS;
    case 6:
    case "CLOSED":
      return SalesReturn_State.CLOSED;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesReturn_State");
  }
}

export function salesReturn_StateToJSON(object: SalesReturn_State): string {
  switch (object) {
    case SalesReturn_State.STATUS_UNKNOWN:
      return "STATUS_UNKNOWN";
    case SalesReturn_State.WAIT_BUYER_RETURN_GOODS:
      return "WAIT_BUYER_RETURN_GOODS";
    case SalesReturn_State.WAIT_SELLER_CONFIRM_GOODS:
      return "WAIT_SELLER_CONFIRM_GOODS";
    case SalesReturn_State.SELLER_CONFIRMING_GOODS:
      return "SELLER_CONFIRMING_GOODS";
    case SalesReturn_State.PENDING_REFUND:
      return "PENDING_REFUND";
    case SalesReturn_State.SUCCESS:
      return "SUCCESS";
    case SalesReturn_State.CLOSED:
      return "CLOSED";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesReturn_State");
  }
}

export enum SalesReturn_ReturnChannel {
  RETURN_CHANNEL_UNSPECIFIED = 0,
  /** RETURN_CHANNEL_SEVEN_ELEVEN - 7-11寄件 */
  RETURN_CHANNEL_SEVEN_ELEVEN = 1,
  /** RETURN_CHANNEL_FAMILY - 全家寄件 */
  RETURN_CHANNEL_FAMILY = 2,
  /** RETURN_CHANNEL_TCAT - 黑貓取件 */
  RETURN_CHANNEL_TCAT = 3,
  /** RETURN_CHANNEL_CUSTOM - 自行寄件 */
  RETURN_CHANNEL_CUSTOM = 10,
}

export function salesReturn_ReturnChannelFromJSON(object: any): SalesReturn_ReturnChannel {
  switch (object) {
    case 0:
    case "RETURN_CHANNEL_UNSPECIFIED":
      return SalesReturn_ReturnChannel.RETURN_CHANNEL_UNSPECIFIED;
    case 1:
    case "RETURN_CHANNEL_SEVEN_ELEVEN":
      return SalesReturn_ReturnChannel.RETURN_CHANNEL_SEVEN_ELEVEN;
    case 2:
    case "RETURN_CHANNEL_FAMILY":
      return SalesReturn_ReturnChannel.RETURN_CHANNEL_FAMILY;
    case 3:
    case "RETURN_CHANNEL_TCAT":
      return SalesReturn_ReturnChannel.RETURN_CHANNEL_TCAT;
    case 10:
    case "RETURN_CHANNEL_CUSTOM":
      return SalesReturn_ReturnChannel.RETURN_CHANNEL_CUSTOM;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesReturn_ReturnChannel");
  }
}

export function salesReturn_ReturnChannelToJSON(object: SalesReturn_ReturnChannel): string {
  switch (object) {
    case SalesReturn_ReturnChannel.RETURN_CHANNEL_UNSPECIFIED:
      return "RETURN_CHANNEL_UNSPECIFIED";
    case SalesReturn_ReturnChannel.RETURN_CHANNEL_SEVEN_ELEVEN:
      return "RETURN_CHANNEL_SEVEN_ELEVEN";
    case SalesReturn_ReturnChannel.RETURN_CHANNEL_FAMILY:
      return "RETURN_CHANNEL_FAMILY";
    case SalesReturn_ReturnChannel.RETURN_CHANNEL_TCAT:
      return "RETURN_CHANNEL_TCAT";
    case SalesReturn_ReturnChannel.RETURN_CHANNEL_CUSTOM:
      return "RETURN_CHANNEL_CUSTOM";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesReturn_ReturnChannel");
  }
}

export enum SalesReturn_RefundChannel {
  REFUND_CHANNEL_UNSPECIFIED = 0,
  /** REFUND_CHANNEL_VIRTUAL - 退款帳戶（虛帳） */
  REFUND_CHANNEL_VIRTUAL = 1,
  /** REFUND_CHANNEL_CREDIT_CARD - 原信用卡 */
  REFUND_CHANNEL_CREDIT_CARD = 2,
  /** REFUND_CHANNEL_CREDIT_CARD_VIRTUAL - 原信用卡 + 退款帳戶 */
  REFUND_CHANNEL_CREDIT_CARD_VIRTUAL = 3,
  /** REFUND_CHANNEL_LINE_PAY - LINE PAY */
  REFUND_CHANNEL_LINE_PAY = 4,
  /** REFUND_CHANNEL_LINE_PAY_VIRTUAL - LINE PAY + 退款帳戶 */
  REFUND_CHANNEL_LINE_PAY_VIRTUAL = 5,
  /** REFUND_CHANNEL_PHYSICAL - 實體帳戶 */
  REFUND_CHANNEL_PHYSICAL = 6,
}

export function salesReturn_RefundChannelFromJSON(object: any): SalesReturn_RefundChannel {
  switch (object) {
    case 0:
    case "REFUND_CHANNEL_UNSPECIFIED":
      return SalesReturn_RefundChannel.REFUND_CHANNEL_UNSPECIFIED;
    case 1:
    case "REFUND_CHANNEL_VIRTUAL":
      return SalesReturn_RefundChannel.REFUND_CHANNEL_VIRTUAL;
    case 2:
    case "REFUND_CHANNEL_CREDIT_CARD":
      return SalesReturn_RefundChannel.REFUND_CHANNEL_CREDIT_CARD;
    case 3:
    case "REFUND_CHANNEL_CREDIT_CARD_VIRTUAL":
      return SalesReturn_RefundChannel.REFUND_CHANNEL_CREDIT_CARD_VIRTUAL;
    case 4:
    case "REFUND_CHANNEL_LINE_PAY":
      return SalesReturn_RefundChannel.REFUND_CHANNEL_LINE_PAY;
    case 5:
    case "REFUND_CHANNEL_LINE_PAY_VIRTUAL":
      return SalesReturn_RefundChannel.REFUND_CHANNEL_LINE_PAY_VIRTUAL;
    case 6:
    case "REFUND_CHANNEL_PHYSICAL":
      return SalesReturn_RefundChannel.REFUND_CHANNEL_PHYSICAL;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesReturn_RefundChannel");
  }
}

export function salesReturn_RefundChannelToJSON(object: SalesReturn_RefundChannel): string {
  switch (object) {
    case SalesReturn_RefundChannel.REFUND_CHANNEL_UNSPECIFIED:
      return "REFUND_CHANNEL_UNSPECIFIED";
    case SalesReturn_RefundChannel.REFUND_CHANNEL_VIRTUAL:
      return "REFUND_CHANNEL_VIRTUAL";
    case SalesReturn_RefundChannel.REFUND_CHANNEL_CREDIT_CARD:
      return "REFUND_CHANNEL_CREDIT_CARD";
    case SalesReturn_RefundChannel.REFUND_CHANNEL_CREDIT_CARD_VIRTUAL:
      return "REFUND_CHANNEL_CREDIT_CARD_VIRTUAL";
    case SalesReturn_RefundChannel.REFUND_CHANNEL_LINE_PAY:
      return "REFUND_CHANNEL_LINE_PAY";
    case SalesReturn_RefundChannel.REFUND_CHANNEL_LINE_PAY_VIRTUAL:
      return "REFUND_CHANNEL_LINE_PAY_VIRTUAL";
    case SalesReturn_RefundChannel.REFUND_CHANNEL_PHYSICAL:
      return "REFUND_CHANNEL_PHYSICAL";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesReturn_RefundChannel");
  }
}

/** 退貨原因 */
export interface SalesReturn_Reason {
  /** 原因 */
  title: string;
  /** 是否需填寫備註 */
  needNote: boolean;
}

/** 退單記錄 */
export interface SalesReturn_Note {
}

/** 來源 */
export enum SalesReturn_Note_Source {
  SOURCE_UNSPECIFIED = 0,
  /** SOURCE_SYSTEM - 系統 */
  SOURCE_SYSTEM = 1,
  /** SOURCE_RETURN - 退單 */
  SOURCE_RETURN = 2,
  /** SOURCE_ONLINE - 線上 */
  SOURCE_ONLINE = 3,
  /** SOURCE_INCALL - 來電 */
  SOURCE_INCALL = 4,
  /** SOURCE_OUTCALL - 去電 */
  SOURCE_OUTCALL = 5,
  /** SOURCE_ORDER - 從訂單複製 */
  SOURCE_ORDER = 99,
}

export function salesReturn_Note_SourceFromJSON(object: any): SalesReturn_Note_Source {
  switch (object) {
    case 0:
    case "SOURCE_UNSPECIFIED":
      return SalesReturn_Note_Source.SOURCE_UNSPECIFIED;
    case 1:
    case "SOURCE_SYSTEM":
      return SalesReturn_Note_Source.SOURCE_SYSTEM;
    case 2:
    case "SOURCE_RETURN":
      return SalesReturn_Note_Source.SOURCE_RETURN;
    case 3:
    case "SOURCE_ONLINE":
      return SalesReturn_Note_Source.SOURCE_ONLINE;
    case 4:
    case "SOURCE_INCALL":
      return SalesReturn_Note_Source.SOURCE_INCALL;
    case 5:
    case "SOURCE_OUTCALL":
      return SalesReturn_Note_Source.SOURCE_OUTCALL;
    case 99:
    case "SOURCE_ORDER":
      return SalesReturn_Note_Source.SOURCE_ORDER;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesReturn_Note_Source");
  }
}

export function salesReturn_Note_SourceToJSON(object: SalesReturn_Note_Source): string {
  switch (object) {
    case SalesReturn_Note_Source.SOURCE_UNSPECIFIED:
      return "SOURCE_UNSPECIFIED";
    case SalesReturn_Note_Source.SOURCE_SYSTEM:
      return "SOURCE_SYSTEM";
    case SalesReturn_Note_Source.SOURCE_RETURN:
      return "SOURCE_RETURN";
    case SalesReturn_Note_Source.SOURCE_ONLINE:
      return "SOURCE_ONLINE";
    case SalesReturn_Note_Source.SOURCE_INCALL:
      return "SOURCE_INCALL";
    case SalesReturn_Note_Source.SOURCE_OUTCALL:
      return "SOURCE_OUTCALL";
    case SalesReturn_Note_Source.SOURCE_ORDER:
      return "SOURCE_ORDER";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SalesReturn_Note_Source");
  }
}

/** 退貨明細 */
export interface SalesReturn_Item {
  /** Unique id generated by the server. */
  id: string;
  /** 訂單品項編號. Unique id generated by the server. */
  orderItemId: string;
  /** 商品編號 */
  skuId: string;
  /** 商品名稱 */
  productName: string;
  /** 商品圖片. Image 360 pixels. */
  productImage: string;
  /** 顏色 */
  colorName: string;
  /** 尺寸 */
  sizeName: string;
  /** 尺碼後綴 */
  sizeSuffix: string;
  /** 單價 */
  unitPrice: string;
  /** 折扣後單價 */
  discountedUnitPrice: string;
  /** 退貨數量 */
  quantity: number;
  /** 小計加總 */
  subtotal: string;
  /** 退貨原因 */
  reason: string;
  /** 退貨原因備註 */
  note: string;
  /** 活動編號 */
  promotionId: string;
  /** 活動名稱 */
  promotionName: string;
  /** 活動攤提折扣 */
  promotionAmortizedDeduction: string;
  /** 活動攤提折扣 */
  returnAmortizedDeduction: string;
  /** 品項成立時間 */
  createTime:
    | Date
    | undefined;
  /** 是否符合活動 */
  promotionQualified: boolean;
}

export interface Refund {
}

export enum Refund_State {
  STATE_UNSPECIFIED = 0,
  /**
   * STATE_REFUND_CANCELLED - 退款取消
   * A refund can only be cancelled at 待退款 state.
   */
  STATE_REFUND_CANCELLED = 1,
  /** STATE_TO_REFUND - 待退款 */
  STATE_TO_REFUND = 2,
  /** STATE_REFUND_REQUESTED - 退款處理中 */
  STATE_REFUND_REQUESTED = 3,
  /** STATE_REFUND_SUCCESS - 退款完成/成功 */
  STATE_REFUND_SUCCESS = 4,
  /** STATE_REFUND_FAILED - 退款失敗 */
  STATE_REFUND_FAILED = 5,
}

export function refund_StateFromJSON(object: any): Refund_State {
  switch (object) {
    case 0:
    case "STATE_UNSPECIFIED":
      return Refund_State.STATE_UNSPECIFIED;
    case 1:
    case "STATE_REFUND_CANCELLED":
      return Refund_State.STATE_REFUND_CANCELLED;
    case 2:
    case "STATE_TO_REFUND":
      return Refund_State.STATE_TO_REFUND;
    case 3:
    case "STATE_REFUND_REQUESTED":
      return Refund_State.STATE_REFUND_REQUESTED;
    case 4:
    case "STATE_REFUND_SUCCESS":
      return Refund_State.STATE_REFUND_SUCCESS;
    case 5:
    case "STATE_REFUND_FAILED":
      return Refund_State.STATE_REFUND_FAILED;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Refund_State");
  }
}

export function refund_StateToJSON(object: Refund_State): string {
  switch (object) {
    case Refund_State.STATE_UNSPECIFIED:
      return "STATE_UNSPECIFIED";
    case Refund_State.STATE_REFUND_CANCELLED:
      return "STATE_REFUND_CANCELLED";
    case Refund_State.STATE_TO_REFUND:
      return "STATE_TO_REFUND";
    case Refund_State.STATE_REFUND_REQUESTED:
      return "STATE_REFUND_REQUESTED";
    case Refund_State.STATE_REFUND_SUCCESS:
      return "STATE_REFUND_SUCCESS";
    case Refund_State.STATE_REFUND_FAILED:
      return "STATE_REFUND_FAILED";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Refund_State");
  }
}

export enum Refund_Type {
  TYPE_UNSPECIFIED = 0,
  /** TYPE_CUSTOMER_REFUND - 出貨前退款/取消訂單（包含後端取消、會員取消、未領取消、出庫異常取消） */
  TYPE_CUSTOMER_REFUND = 1,
  /** TYPE_OVERSELL_REFUND - 超賣時需要退款調整 */
  TYPE_OVERSELL_REFUND = 2,
  /** TYPE_CUSTOMER_RETURN - 退貨退款（因退貨而產生的退款） */
  TYPE_CUSTOMER_RETURN = 3,
  /** TYPE_CS_RETURN - 由 ERP 申請的退貨退款 */
  TYPE_CS_RETURN = 4,
}

export function refund_TypeFromJSON(object: any): Refund_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return Refund_Type.TYPE_UNSPECIFIED;
    case 1:
    case "TYPE_CUSTOMER_REFUND":
      return Refund_Type.TYPE_CUSTOMER_REFUND;
    case 2:
    case "TYPE_OVERSELL_REFUND":
      return Refund_Type.TYPE_OVERSELL_REFUND;
    case 3:
    case "TYPE_CUSTOMER_RETURN":
      return Refund_Type.TYPE_CUSTOMER_RETURN;
    case 4:
    case "TYPE_CS_RETURN":
      return Refund_Type.TYPE_CS_RETURN;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Refund_Type");
  }
}

export function refund_TypeToJSON(object: Refund_Type): string {
  switch (object) {
    case Refund_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case Refund_Type.TYPE_CUSTOMER_REFUND:
      return "TYPE_CUSTOMER_REFUND";
    case Refund_Type.TYPE_OVERSELL_REFUND:
      return "TYPE_OVERSELL_REFUND";
    case Refund_Type.TYPE_CUSTOMER_RETURN:
      return "TYPE_CUSTOMER_RETURN";
    case Refund_Type.TYPE_CS_RETURN:
      return "TYPE_CS_RETURN";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Refund_Type");
  }
}

/** 發票處理方式及資訊 */
export interface Receipt {
  /** Required. 發票處理方式 */
  receiptMethod: SalesOrder_ReceiptMethod;
  /** Optional. 統一編號, required when receipt_method is RECEIPT_METHOD_TAX_ID_NUMBER */
  taxId: string;
  /** Optional. 捐贈單位, required when receipt_method is RECEIPT_METHOD_DONATION_CODE */
  donateUnitId: string;
  /** Optional. 手機條碼, required when receipt_method is RECEIPT_METHOD_MOBILE_BARCODE */
  mobileBarcode: string;
  /** Optional. 紙本發票收件人姓名 */
  recipientName: string;
  /** Optional. 紙本發票收件人郵遞區號 */
  recipientPostcode: string;
  /** Optional. 紙本發票收件人縣市 */
  recipientCity: string;
  /** Optional. 紙本發票收件人地區 */
  recipientArea: string;
  /** Optional. 紙本發票收件人街道門牌 */
  recipientStreet: string;
}

/** 捐贈單位 */
export interface Receipt_DonationUnit {
  /** 捐贈碼 */
  id: string;
  /** 捐贈單位名稱 */
  name: string;
}

/** 評價 */
export interface Rating {
  /** 訂單明細 ID */
  itemId: string;
  /** 訂單 ID */
  orderId: string;
  /** 商品款號 */
  productId: string;
  /** 商品編號 */
  skuId: string;
  /** 評價建立時間 */
  createTime:
    | Date
    | undefined;
  /** 評價內容 */
  content: string;
  /** 是否隱藏 */
  hide: boolean;
  /** 回覆內容 */
  reply: string;
  /** 回覆時間 */
  replyTime: Date | undefined;
}

export interface Payment {
  /** 支付單 ID */
  id: string;
  /** 訂單 ID */
  orderSourceId: string;
  /** 支付平台 app ID */
  externalAppId: string;
  /** 付款類型 */
  paymentType: SalesOrder_PaymentType;
  /** 支付創建平台 */
  platform: App_Platform;
  /** 金額 */
  totalAmount: string;
  /** 狀態 */
  state: number;
  /** 建立時間 */
  createTime:
    | Date
    | undefined;
  /** 外部編號 */
  externalId: string;
  /** 交易授權碼 for 信用卡 */
  authorizationCode: string;
  /** 請求時間 */
  reqTime:
    | Date
    | undefined;
  /** 回應時間 */
  respTime:
    | Date
    | undefined;
  /** 信用卡類型 */
  creditCardType: number;
  /** 高風險訂單 */
  highRisk: boolean;
  /** 3D驗證 for 信用卡 */
  secureVerification: boolean;
}

/** 信用卡收單銀行 */
export enum Payment_AcquiringBank {
  ACQUIRING_BANK_UNSPECIFIED = 0,
  /** ACQUIRING_BANK_ESUN - 玉山 */
  ACQUIRING_BANK_ESUN = 1,
}

export function payment_AcquiringBankFromJSON(object: any): Payment_AcquiringBank {
  switch (object) {
    case 0:
    case "ACQUIRING_BANK_UNSPECIFIED":
      return Payment_AcquiringBank.ACQUIRING_BANK_UNSPECIFIED;
    case 1:
    case "ACQUIRING_BANK_ESUN":
      return Payment_AcquiringBank.ACQUIRING_BANK_ESUN;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Payment_AcquiringBank");
  }
}

export function payment_AcquiringBankToJSON(object: Payment_AcquiringBank): string {
  switch (object) {
    case Payment_AcquiringBank.ACQUIRING_BANK_UNSPECIFIED:
      return "ACQUIRING_BANK_UNSPECIFIED";
    case Payment_AcquiringBank.ACQUIRING_BANK_ESUN:
      return "ACQUIRING_BANK_ESUN";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Payment_AcquiringBank");
  }
}

/** 發票資訊 */
export interface EInvoice {
  /** Required. 發票號碼 */
  number: string;
  /** Required. 發票編號 */
  orderSourceId: string;
  /** Required. 發票聯式 */
  uniform: InvoiceUniform;
  /** Required. 發票日期 */
  invoiceDate:
    | Date
    | undefined;
  /** Required. 發票開立時間 */
  issuedTime:
    | Date
    | undefined;
  /** Required. 隨機碼 */
  randomCode: string;
  /** Required. 統一編號 */
  taxRegistrationNo: string;
  /** Required. 一維條碼 */
  barcode: string;
  /** Required. 左 QRCode */
  leftQrcode: string;
  /** Required. 右 QRCode */
  rightQrcode: string;
  /** Optional. 備註 */
  memo: string;
  /** Required. 品項 */
  items: EInvoice_Item[];
  /** Required. 運費 */
  shippingFee: string;
  /** Required. 應補退差額 */
  compensationAmount: string;
  /** Required. 發票開立金額（此欄位僅用來驗證 ERP 與 STORE 金額是否正確） */
  totalAmount: string;
}

/** 品項 */
export interface EInvoice_Item {
  /** 品名 */
  name: string;
  /** 發票開立金額（此欄位僅用來驗證 ERP 與 STORE 金額是否正確） */
  totalAmount: string;
  /** 訂單明細編號 */
  itemId: string;
}

/** 銷貨折讓資訊 */
export interface SalesAllowance {
  /** Required. 折讓單號碼 */
  number: string;
  /** Required. 折讓單日期 */
  date:
    | Date
    | undefined;
  /** Required. 折讓單金額 */
  amount: string;
  /** Required. 折讓單未稅金額 */
  amountBeforeTax: string;
  /** Required. 稅額 */
  taxAmount: string;
  /** Required. 運費 */
  shippingFee: string;
  /** Required. 應補退差額 */
  compensationAmount: string;
  /** Required. 品項 */
  items: SalesAllowance_Item[];
}

/** 品項 */
export interface SalesAllowance_Item {
  /** Required. 品名 */
  name: string;
  /** Required. 數量 */
  quantity: number;
  /** Required. 單價 */
  unitPrice: string;
  /** Required. 訂單明細編號 */
  itemId: string;
}

/** 配送編號 */
export interface TrackingNumber {
  /** Required. 配送編號 id */
  id: string;
  /** Required. 配送編號類型 */
  type: TrackingNumber_Type;
  /** Required. 名稱 */
  name: string;
  /** Required. 建立時間 */
  createTime:
    | Date
    | undefined;
  /** Required. 開始號碼 */
  startNumber: string;
  /** Required. 結束號碼 */
  endNumber: string;
  /** Required. 核發數量 */
  quantity: number;
  /** Required. 使用數量 */
  usageQuantity: number;
}

/** 類型 */
export enum TrackingNumber_Type {
  TYPE_UNSPECIFIED = 0,
  /** TYPE_SEVEN - 7-11 */
  TYPE_SEVEN = 1,
  /** TYPE_FAMILY - 全家 */
  TYPE_FAMILY = 2,
  /** TYPE_T_CAT_CREDIT_CARD - 黑貓-宅配信用卡 */
  TYPE_T_CAT_CREDIT_CARD = 3,
  /** TYPE_T_CAT_COD - 黑貓-宅配貨到付款 */
  TYPE_T_CAT_COD = 4,
  /** TYPE_T_CAT_RETURN - 黑貓-宅配退貨 */
  TYPE_T_CAT_RETURN = 5,
}

export function trackingNumber_TypeFromJSON(object: any): TrackingNumber_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return TrackingNumber_Type.TYPE_UNSPECIFIED;
    case 1:
    case "TYPE_SEVEN":
      return TrackingNumber_Type.TYPE_SEVEN;
    case 2:
    case "TYPE_FAMILY":
      return TrackingNumber_Type.TYPE_FAMILY;
    case 3:
    case "TYPE_T_CAT_CREDIT_CARD":
      return TrackingNumber_Type.TYPE_T_CAT_CREDIT_CARD;
    case 4:
    case "TYPE_T_CAT_COD":
      return TrackingNumber_Type.TYPE_T_CAT_COD;
    case 5:
    case "TYPE_T_CAT_RETURN":
      return TrackingNumber_Type.TYPE_T_CAT_RETURN;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum TrackingNumber_Type");
  }
}

export function trackingNumber_TypeToJSON(object: TrackingNumber_Type): string {
  switch (object) {
    case TrackingNumber_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case TrackingNumber_Type.TYPE_SEVEN:
      return "TYPE_SEVEN";
    case TrackingNumber_Type.TYPE_FAMILY:
      return "TYPE_FAMILY";
    case TrackingNumber_Type.TYPE_T_CAT_CREDIT_CARD:
      return "TYPE_T_CAT_CREDIT_CARD";
    case TrackingNumber_Type.TYPE_T_CAT_COD:
      return "TYPE_T_CAT_COD";
    case TrackingNumber_Type.TYPE_T_CAT_RETURN:
      return "TYPE_T_CAT_RETURN";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum TrackingNumber_Type");
  }
}

function createBaseSalesOrder(): SalesOrder {
  return {
    id: "",
    state: 0,
    createTime: undefined,
    platform: 0,
    paymentType: 0,
    authorizationTime: undefined,
    quantity: 0,
    subtotal: "",
    shipping: "",
    balanceDeduction: "",
    promotionDeduction: "",
    total: "",
    logisticsCompany: 0,
    receipt: undefined,
    deleted: false,
    recipient: undefined,
    items: [],
    customerId: "",
    customerFriendlyId: "",
    customerName: "",
    customerState: 0,
    customerProvider: 0,
    customerCreateTime: undefined,
    creditCardSuffix: "",
    exchangeRateUsdNtd: "",
    returnDeclaration: false,
    shippingThreshold: "",
    unpaidCanceled: false,
    cancelTime: undefined,
    chargeableWeight: "",
    onlineSessionId: "",
    adId: "",
    paymentState: 0,
    shippingFeeSnapshot: "",
  };
}

export const SalesOrder = {
  fromJSON(object: any): SalesOrder {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      state: isSet(object.state) ? salesOrder_StateFromJSON(object.state) : 0,
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      platform: isSet(object.platform) ? app_PlatformFromJSON(object.platform) : 0,
      paymentType: isSet(object.paymentType) ? salesOrder_PaymentTypeFromJSON(object.paymentType) : 0,
      authorizationTime: isSet(object.authorizationTime) ? fromJsonTimestamp(object.authorizationTime) : undefined,
      quantity: isSet(object.quantity) ? Number(object.quantity) : 0,
      subtotal: isSet(object.subtotal) ? String(object.subtotal) : "",
      shipping: isSet(object.shipping) ? String(object.shipping) : "",
      balanceDeduction: isSet(object.balanceDeduction) ? String(object.balanceDeduction) : "",
      promotionDeduction: isSet(object.promotionDeduction) ? String(object.promotionDeduction) : "",
      total: isSet(object.total) ? String(object.total) : "",
      logisticsCompany: isSet(object.logisticsCompany)
        ? salesOrder_LogisticsCompanyFromJSON(object.logisticsCompany)
        : 0,
      receipt: isSet(object.receipt) ? Receipt.fromJSON(object.receipt) : undefined,
      deleted: isSet(object.deleted) ? Boolean(object.deleted) : false,
      recipient: isSet(object.recipient) ? Recipient.fromJSON(object.recipient) : undefined,
      items: Array.isArray(object?.items) ? object.items.map((e: any) => SalesOrder_Item.fromJSON(e)) : [],
      customerId: isSet(object.customerId) ? String(object.customerId) : "",
      customerFriendlyId: isSet(object.customerFriendlyId) ? String(object.customerFriendlyId) : "",
      customerName: isSet(object.customerName) ? String(object.customerName) : "",
      customerState: isSet(object.customerState) ? customer_StateFromJSON(object.customerState) : 0,
      customerProvider: isSet(object.customerProvider) ? customer_ProviderFromJSON(object.customerProvider) : 0,
      customerCreateTime: isSet(object.customerCreateTime) ? fromJsonTimestamp(object.customerCreateTime) : undefined,
      creditCardSuffix: isSet(object.creditCardSuffix) ? String(object.creditCardSuffix) : "",
      exchangeRateUsdNtd: isSet(object.exchangeRateUsdNtd) ? String(object.exchangeRateUsdNtd) : "",
      returnDeclaration: isSet(object.returnDeclaration) ? Boolean(object.returnDeclaration) : false,
      shippingThreshold: isSet(object.shippingThreshold) ? String(object.shippingThreshold) : "",
      unpaidCanceled: isSet(object.unpaidCanceled) ? Boolean(object.unpaidCanceled) : false,
      cancelTime: isSet(object.cancelTime) ? fromJsonTimestamp(object.cancelTime) : undefined,
      chargeableWeight: isSet(object.chargeableWeight) ? String(object.chargeableWeight) : "",
      onlineSessionId: isSet(object.onlineSessionId) ? String(object.onlineSessionId) : "",
      adId: isSet(object.adId) ? String(object.adId) : "",
      paymentState: isSet(object.paymentState) ? Number(object.paymentState) : 0,
      shippingFeeSnapshot: isSet(object.shippingFeeSnapshot) ? String(object.shippingFeeSnapshot) : "",
    };
  },

  toJSON(message: SalesOrder): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.state !== undefined && (obj.state = salesOrder_StateToJSON(message.state));
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.platform !== undefined && (obj.platform = app_PlatformToJSON(message.platform));
    message.paymentType !== undefined && (obj.paymentType = salesOrder_PaymentTypeToJSON(message.paymentType));
    message.authorizationTime !== undefined && (obj.authorizationTime = message.authorizationTime.toISOString());
    message.quantity !== undefined && (obj.quantity = Math.round(message.quantity));
    message.subtotal !== undefined && (obj.subtotal = message.subtotal);
    message.shipping !== undefined && (obj.shipping = message.shipping);
    message.balanceDeduction !== undefined && (obj.balanceDeduction = message.balanceDeduction);
    message.promotionDeduction !== undefined && (obj.promotionDeduction = message.promotionDeduction);
    message.total !== undefined && (obj.total = message.total);
    message.logisticsCompany !== undefined &&
      (obj.logisticsCompany = salesOrder_LogisticsCompanyToJSON(message.logisticsCompany));
    message.receipt !== undefined && (obj.receipt = message.receipt ? Receipt.toJSON(message.receipt) : undefined);
    message.deleted !== undefined && (obj.deleted = message.deleted);
    message.recipient !== undefined &&
      (obj.recipient = message.recipient ? Recipient.toJSON(message.recipient) : undefined);
    if (message.items) {
      obj.items = message.items.map((e) => e ? SalesOrder_Item.toJSON(e) : undefined);
    } else {
      obj.items = [];
    }
    message.customerId !== undefined && (obj.customerId = message.customerId);
    message.customerFriendlyId !== undefined && (obj.customerFriendlyId = message.customerFriendlyId);
    message.customerName !== undefined && (obj.customerName = message.customerName);
    message.customerState !== undefined && (obj.customerState = customer_StateToJSON(message.customerState));
    message.customerProvider !== undefined &&
      (obj.customerProvider = customer_ProviderToJSON(message.customerProvider));
    message.customerCreateTime !== undefined && (obj.customerCreateTime = message.customerCreateTime.toISOString());
    message.creditCardSuffix !== undefined && (obj.creditCardSuffix = message.creditCardSuffix);
    message.exchangeRateUsdNtd !== undefined && (obj.exchangeRateUsdNtd = message.exchangeRateUsdNtd);
    message.returnDeclaration !== undefined && (obj.returnDeclaration = message.returnDeclaration);
    message.shippingThreshold !== undefined && (obj.shippingThreshold = message.shippingThreshold);
    message.unpaidCanceled !== undefined && (obj.unpaidCanceled = message.unpaidCanceled);
    message.cancelTime !== undefined && (obj.cancelTime = message.cancelTime.toISOString());
    message.chargeableWeight !== undefined && (obj.chargeableWeight = message.chargeableWeight);
    message.onlineSessionId !== undefined && (obj.onlineSessionId = message.onlineSessionId);
    message.adId !== undefined && (obj.adId = message.adId);
    message.paymentState !== undefined && (obj.paymentState = Math.round(message.paymentState));
    message.shippingFeeSnapshot !== undefined && (obj.shippingFeeSnapshot = message.shippingFeeSnapshot);
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesOrder>, I>>(base?: I): SalesOrder {
    return SalesOrder.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesOrder>, I>>(object: I): SalesOrder {
    const message = createBaseSalesOrder();
    message.id = object.id ?? "";
    message.state = object.state ?? 0;
    message.createTime = object.createTime ?? undefined;
    message.platform = object.platform ?? 0;
    message.paymentType = object.paymentType ?? 0;
    message.authorizationTime = object.authorizationTime ?? undefined;
    message.quantity = object.quantity ?? 0;
    message.subtotal = object.subtotal ?? "";
    message.shipping = object.shipping ?? "";
    message.balanceDeduction = object.balanceDeduction ?? "";
    message.promotionDeduction = object.promotionDeduction ?? "";
    message.total = object.total ?? "";
    message.logisticsCompany = object.logisticsCompany ?? 0;
    message.receipt = (object.receipt !== undefined && object.receipt !== null)
      ? Receipt.fromPartial(object.receipt)
      : undefined;
    message.deleted = object.deleted ?? false;
    message.recipient = (object.recipient !== undefined && object.recipient !== null)
      ? Recipient.fromPartial(object.recipient)
      : undefined;
    message.items = object.items?.map((e) => SalesOrder_Item.fromPartial(e)) || [];
    message.customerId = object.customerId ?? "";
    message.customerFriendlyId = object.customerFriendlyId ?? "";
    message.customerName = object.customerName ?? "";
    message.customerState = object.customerState ?? 0;
    message.customerProvider = object.customerProvider ?? 0;
    message.customerCreateTime = object.customerCreateTime ?? undefined;
    message.creditCardSuffix = object.creditCardSuffix ?? "";
    message.exchangeRateUsdNtd = object.exchangeRateUsdNtd ?? "";
    message.returnDeclaration = object.returnDeclaration ?? false;
    message.shippingThreshold = object.shippingThreshold ?? "";
    message.unpaidCanceled = object.unpaidCanceled ?? false;
    message.cancelTime = object.cancelTime ?? undefined;
    message.chargeableWeight = object.chargeableWeight ?? "";
    message.onlineSessionId = object.onlineSessionId ?? "";
    message.adId = object.adId ?? "";
    message.paymentState = object.paymentState ?? 0;
    message.shippingFeeSnapshot = object.shippingFeeSnapshot ?? "";
    return message;
  },
};

function createBaseSalesOrder_Note(): SalesOrder_Note {
  return {};
}

export const SalesOrder_Note = {
  fromJSON(_: any): SalesOrder_Note {
    return {};
  },

  toJSON(_: SalesOrder_Note): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesOrder_Note>, I>>(base?: I): SalesOrder_Note {
    return SalesOrder_Note.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesOrder_Note>, I>>(_: I): SalesOrder_Note {
    const message = createBaseSalesOrder_Note();
    return message;
  },
};

function createBaseSalesOrder_Item(): SalesOrder_Item {
  return {
    id: "",
    skuId: "",
    productName: "",
    productImage: "",
    colorName: "",
    sizeName: "",
    sizeSuffix: "",
    unitPrice: "",
    discountedUnitPrice: "",
    promotionId: "",
    promotionName: "",
    promotionAmortizedDeduction: "",
    quantity: 0,
    subtotal: "",
    unitPriceSubtotal: "",
    createTime: undefined,
    promotionQualified: false,
  };
}

export const SalesOrder_Item = {
  fromJSON(object: any): SalesOrder_Item {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      skuId: isSet(object.skuId) ? String(object.skuId) : "",
      productName: isSet(object.productName) ? String(object.productName) : "",
      productImage: isSet(object.productImage) ? String(object.productImage) : "",
      colorName: isSet(object.colorName) ? String(object.colorName) : "",
      sizeName: isSet(object.sizeName) ? String(object.sizeName) : "",
      sizeSuffix: isSet(object.sizeSuffix) ? String(object.sizeSuffix) : "",
      unitPrice: isSet(object.unitPrice) ? String(object.unitPrice) : "",
      discountedUnitPrice: isSet(object.discountedUnitPrice) ? String(object.discountedUnitPrice) : "",
      promotionId: isSet(object.promotionId) ? String(object.promotionId) : "",
      promotionName: isSet(object.promotionName) ? String(object.promotionName) : "",
      promotionAmortizedDeduction: isSet(object.promotionAmortizedDeduction)
        ? String(object.promotionAmortizedDeduction)
        : "",
      quantity: isSet(object.quantity) ? Number(object.quantity) : 0,
      subtotal: isSet(object.subtotal) ? String(object.subtotal) : "",
      unitPriceSubtotal: isSet(object.unitPriceSubtotal) ? String(object.unitPriceSubtotal) : "",
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      promotionQualified: isSet(object.promotionQualified) ? Boolean(object.promotionQualified) : false,
    };
  },

  toJSON(message: SalesOrder_Item): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.skuId !== undefined && (obj.skuId = message.skuId);
    message.productName !== undefined && (obj.productName = message.productName);
    message.productImage !== undefined && (obj.productImage = message.productImage);
    message.colorName !== undefined && (obj.colorName = message.colorName);
    message.sizeName !== undefined && (obj.sizeName = message.sizeName);
    message.sizeSuffix !== undefined && (obj.sizeSuffix = message.sizeSuffix);
    message.unitPrice !== undefined && (obj.unitPrice = message.unitPrice);
    message.discountedUnitPrice !== undefined && (obj.discountedUnitPrice = message.discountedUnitPrice);
    message.promotionId !== undefined && (obj.promotionId = message.promotionId);
    message.promotionName !== undefined && (obj.promotionName = message.promotionName);
    message.promotionAmortizedDeduction !== undefined &&
      (obj.promotionAmortizedDeduction = message.promotionAmortizedDeduction);
    message.quantity !== undefined && (obj.quantity = Math.round(message.quantity));
    message.subtotal !== undefined && (obj.subtotal = message.subtotal);
    message.unitPriceSubtotal !== undefined && (obj.unitPriceSubtotal = message.unitPriceSubtotal);
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.promotionQualified !== undefined && (obj.promotionQualified = message.promotionQualified);
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesOrder_Item>, I>>(base?: I): SalesOrder_Item {
    return SalesOrder_Item.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesOrder_Item>, I>>(object: I): SalesOrder_Item {
    const message = createBaseSalesOrder_Item();
    message.id = object.id ?? "";
    message.skuId = object.skuId ?? "";
    message.productName = object.productName ?? "";
    message.productImage = object.productImage ?? "";
    message.colorName = object.colorName ?? "";
    message.sizeName = object.sizeName ?? "";
    message.sizeSuffix = object.sizeSuffix ?? "";
    message.unitPrice = object.unitPrice ?? "";
    message.discountedUnitPrice = object.discountedUnitPrice ?? "";
    message.promotionId = object.promotionId ?? "";
    message.promotionName = object.promotionName ?? "";
    message.promotionAmortizedDeduction = object.promotionAmortizedDeduction ?? "";
    message.quantity = object.quantity ?? 0;
    message.subtotal = object.subtotal ?? "";
    message.unitPriceSubtotal = object.unitPriceSubtotal ?? "";
    message.createTime = object.createTime ?? undefined;
    message.promotionQualified = object.promotionQualified ?? false;
    return message;
  },
};

function createBaseSalesReturn(): SalesReturn {
  return {
    id: "",
    orderId: "",
    state: 0,
    platform: 0,
    createTime: undefined,
    updateTime: undefined,
    paymentType: 0,
    items: [],
    totalQuantity: 0,
    total: "",
    refundAmount: "",
    returnChannel: 0,
    shipmentTrackingNumber: "",
    shipmentValidationNo: "",
    refundChannel: 0,
    senderName: "",
    senderCity: "",
    senderArea: "",
    senderStreet: "",
    senderPostcode: "",
    phoneUploaded: false,
  };
}

export const SalesReturn = {
  fromJSON(object: any): SalesReturn {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      orderId: isSet(object.orderId) ? String(object.orderId) : "",
      state: isSet(object.state) ? salesReturn_StateFromJSON(object.state) : 0,
      platform: isSet(object.platform) ? app_PlatformFromJSON(object.platform) : 0,
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      updateTime: isSet(object.updateTime) ? fromJsonTimestamp(object.updateTime) : undefined,
      paymentType: isSet(object.paymentType) ? salesOrder_PaymentTypeFromJSON(object.paymentType) : 0,
      items: Array.isArray(object?.items) ? object.items.map((e: any) => SalesReturn_Item.fromJSON(e)) : [],
      totalQuantity: isSet(object.totalQuantity) ? Number(object.totalQuantity) : 0,
      total: isSet(object.total) ? String(object.total) : "",
      refundAmount: isSet(object.refundAmount) ? String(object.refundAmount) : "",
      returnChannel: isSet(object.returnChannel) ? salesReturn_ReturnChannelFromJSON(object.returnChannel) : 0,
      shipmentTrackingNumber: isSet(object.shipmentTrackingNumber) ? String(object.shipmentTrackingNumber) : "",
      shipmentValidationNo: isSet(object.shipmentValidationNo) ? String(object.shipmentValidationNo) : "",
      refundChannel: isSet(object.refundChannel) ? salesReturn_RefundChannelFromJSON(object.refundChannel) : 0,
      senderName: isSet(object.senderName) ? String(object.senderName) : "",
      senderCity: isSet(object.senderCity) ? String(object.senderCity) : "",
      senderArea: isSet(object.senderArea) ? String(object.senderArea) : "",
      senderStreet: isSet(object.senderStreet) ? String(object.senderStreet) : "",
      senderPostcode: isSet(object.senderPostcode) ? String(object.senderPostcode) : "",
      phoneUploaded: isSet(object.phoneUploaded) ? Boolean(object.phoneUploaded) : false,
    };
  },

  toJSON(message: SalesReturn): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.state !== undefined && (obj.state = salesReturn_StateToJSON(message.state));
    message.platform !== undefined && (obj.platform = app_PlatformToJSON(message.platform));
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.updateTime !== undefined && (obj.updateTime = message.updateTime.toISOString());
    message.paymentType !== undefined && (obj.paymentType = salesOrder_PaymentTypeToJSON(message.paymentType));
    if (message.items) {
      obj.items = message.items.map((e) => e ? SalesReturn_Item.toJSON(e) : undefined);
    } else {
      obj.items = [];
    }
    message.totalQuantity !== undefined && (obj.totalQuantity = Math.round(message.totalQuantity));
    message.total !== undefined && (obj.total = message.total);
    message.refundAmount !== undefined && (obj.refundAmount = message.refundAmount);
    message.returnChannel !== undefined && (obj.returnChannel = salesReturn_ReturnChannelToJSON(message.returnChannel));
    message.shipmentTrackingNumber !== undefined && (obj.shipmentTrackingNumber = message.shipmentTrackingNumber);
    message.shipmentValidationNo !== undefined && (obj.shipmentValidationNo = message.shipmentValidationNo);
    message.refundChannel !== undefined && (obj.refundChannel = salesReturn_RefundChannelToJSON(message.refundChannel));
    message.senderName !== undefined && (obj.senderName = message.senderName);
    message.senderCity !== undefined && (obj.senderCity = message.senderCity);
    message.senderArea !== undefined && (obj.senderArea = message.senderArea);
    message.senderStreet !== undefined && (obj.senderStreet = message.senderStreet);
    message.senderPostcode !== undefined && (obj.senderPostcode = message.senderPostcode);
    message.phoneUploaded !== undefined && (obj.phoneUploaded = message.phoneUploaded);
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesReturn>, I>>(base?: I): SalesReturn {
    return SalesReturn.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesReturn>, I>>(object: I): SalesReturn {
    const message = createBaseSalesReturn();
    message.id = object.id ?? "";
    message.orderId = object.orderId ?? "";
    message.state = object.state ?? 0;
    message.platform = object.platform ?? 0;
    message.createTime = object.createTime ?? undefined;
    message.updateTime = object.updateTime ?? undefined;
    message.paymentType = object.paymentType ?? 0;
    message.items = object.items?.map((e) => SalesReturn_Item.fromPartial(e)) || [];
    message.totalQuantity = object.totalQuantity ?? 0;
    message.total = object.total ?? "";
    message.refundAmount = object.refundAmount ?? "";
    message.returnChannel = object.returnChannel ?? 0;
    message.shipmentTrackingNumber = object.shipmentTrackingNumber ?? "";
    message.shipmentValidationNo = object.shipmentValidationNo ?? "";
    message.refundChannel = object.refundChannel ?? 0;
    message.senderName = object.senderName ?? "";
    message.senderCity = object.senderCity ?? "";
    message.senderArea = object.senderArea ?? "";
    message.senderStreet = object.senderStreet ?? "";
    message.senderPostcode = object.senderPostcode ?? "";
    message.phoneUploaded = object.phoneUploaded ?? false;
    return message;
  },
};

function createBaseSalesReturn_Reason(): SalesReturn_Reason {
  return { title: "", needNote: false };
}

export const SalesReturn_Reason = {
  fromJSON(object: any): SalesReturn_Reason {
    return {
      title: isSet(object.title) ? String(object.title) : "",
      needNote: isSet(object.needNote) ? Boolean(object.needNote) : false,
    };
  },

  toJSON(message: SalesReturn_Reason): unknown {
    const obj: any = {};
    message.title !== undefined && (obj.title = message.title);
    message.needNote !== undefined && (obj.needNote = message.needNote);
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesReturn_Reason>, I>>(base?: I): SalesReturn_Reason {
    return SalesReturn_Reason.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesReturn_Reason>, I>>(object: I): SalesReturn_Reason {
    const message = createBaseSalesReturn_Reason();
    message.title = object.title ?? "";
    message.needNote = object.needNote ?? false;
    return message;
  },
};

function createBaseSalesReturn_Note(): SalesReturn_Note {
  return {};
}

export const SalesReturn_Note = {
  fromJSON(_: any): SalesReturn_Note {
    return {};
  },

  toJSON(_: SalesReturn_Note): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesReturn_Note>, I>>(base?: I): SalesReturn_Note {
    return SalesReturn_Note.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesReturn_Note>, I>>(_: I): SalesReturn_Note {
    const message = createBaseSalesReturn_Note();
    return message;
  },
};

function createBaseSalesReturn_Item(): SalesReturn_Item {
  return {
    id: "",
    orderItemId: "",
    skuId: "",
    productName: "",
    productImage: "",
    colorName: "",
    sizeName: "",
    sizeSuffix: "",
    unitPrice: "",
    discountedUnitPrice: "",
    quantity: 0,
    subtotal: "",
    reason: "",
    note: "",
    promotionId: "",
    promotionName: "",
    promotionAmortizedDeduction: "",
    returnAmortizedDeduction: "",
    createTime: undefined,
    promotionQualified: false,
  };
}

export const SalesReturn_Item = {
  fromJSON(object: any): SalesReturn_Item {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      orderItemId: isSet(object.orderItemId) ? String(object.orderItemId) : "",
      skuId: isSet(object.skuId) ? String(object.skuId) : "",
      productName: isSet(object.productName) ? String(object.productName) : "",
      productImage: isSet(object.productImage) ? String(object.productImage) : "",
      colorName: isSet(object.colorName) ? String(object.colorName) : "",
      sizeName: isSet(object.sizeName) ? String(object.sizeName) : "",
      sizeSuffix: isSet(object.sizeSuffix) ? String(object.sizeSuffix) : "",
      unitPrice: isSet(object.unitPrice) ? String(object.unitPrice) : "",
      discountedUnitPrice: isSet(object.discountedUnitPrice) ? String(object.discountedUnitPrice) : "",
      quantity: isSet(object.quantity) ? Number(object.quantity) : 0,
      subtotal: isSet(object.subtotal) ? String(object.subtotal) : "",
      reason: isSet(object.reason) ? String(object.reason) : "",
      note: isSet(object.note) ? String(object.note) : "",
      promotionId: isSet(object.promotionId) ? String(object.promotionId) : "",
      promotionName: isSet(object.promotionName) ? String(object.promotionName) : "",
      promotionAmortizedDeduction: isSet(object.promotionAmortizedDeduction)
        ? String(object.promotionAmortizedDeduction)
        : "",
      returnAmortizedDeduction: isSet(object.returnAmortizedDeduction) ? String(object.returnAmortizedDeduction) : "",
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      promotionQualified: isSet(object.promotionQualified) ? Boolean(object.promotionQualified) : false,
    };
  },

  toJSON(message: SalesReturn_Item): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.orderItemId !== undefined && (obj.orderItemId = message.orderItemId);
    message.skuId !== undefined && (obj.skuId = message.skuId);
    message.productName !== undefined && (obj.productName = message.productName);
    message.productImage !== undefined && (obj.productImage = message.productImage);
    message.colorName !== undefined && (obj.colorName = message.colorName);
    message.sizeName !== undefined && (obj.sizeName = message.sizeName);
    message.sizeSuffix !== undefined && (obj.sizeSuffix = message.sizeSuffix);
    message.unitPrice !== undefined && (obj.unitPrice = message.unitPrice);
    message.discountedUnitPrice !== undefined && (obj.discountedUnitPrice = message.discountedUnitPrice);
    message.quantity !== undefined && (obj.quantity = Math.round(message.quantity));
    message.subtotal !== undefined && (obj.subtotal = message.subtotal);
    message.reason !== undefined && (obj.reason = message.reason);
    message.note !== undefined && (obj.note = message.note);
    message.promotionId !== undefined && (obj.promotionId = message.promotionId);
    message.promotionName !== undefined && (obj.promotionName = message.promotionName);
    message.promotionAmortizedDeduction !== undefined &&
      (obj.promotionAmortizedDeduction = message.promotionAmortizedDeduction);
    message.returnAmortizedDeduction !== undefined && (obj.returnAmortizedDeduction = message.returnAmortizedDeduction);
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.promotionQualified !== undefined && (obj.promotionQualified = message.promotionQualified);
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesReturn_Item>, I>>(base?: I): SalesReturn_Item {
    return SalesReturn_Item.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesReturn_Item>, I>>(object: I): SalesReturn_Item {
    const message = createBaseSalesReturn_Item();
    message.id = object.id ?? "";
    message.orderItemId = object.orderItemId ?? "";
    message.skuId = object.skuId ?? "";
    message.productName = object.productName ?? "";
    message.productImage = object.productImage ?? "";
    message.colorName = object.colorName ?? "";
    message.sizeName = object.sizeName ?? "";
    message.sizeSuffix = object.sizeSuffix ?? "";
    message.unitPrice = object.unitPrice ?? "";
    message.discountedUnitPrice = object.discountedUnitPrice ?? "";
    message.quantity = object.quantity ?? 0;
    message.subtotal = object.subtotal ?? "";
    message.reason = object.reason ?? "";
    message.note = object.note ?? "";
    message.promotionId = object.promotionId ?? "";
    message.promotionName = object.promotionName ?? "";
    message.promotionAmortizedDeduction = object.promotionAmortizedDeduction ?? "";
    message.returnAmortizedDeduction = object.returnAmortizedDeduction ?? "";
    message.createTime = object.createTime ?? undefined;
    message.promotionQualified = object.promotionQualified ?? false;
    return message;
  },
};

function createBaseRefund(): Refund {
  return {};
}

export const Refund = {
  fromJSON(_: any): Refund {
    return {};
  },

  toJSON(_: Refund): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Refund>, I>>(base?: I): Refund {
    return Refund.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Refund>, I>>(_: I): Refund {
    const message = createBaseRefund();
    return message;
  },
};

function createBaseReceipt(): Receipt {
  return {
    receiptMethod: 0,
    taxId: "",
    donateUnitId: "",
    mobileBarcode: "",
    recipientName: "",
    recipientPostcode: "",
    recipientCity: "",
    recipientArea: "",
    recipientStreet: "",
  };
}

export const Receipt = {
  fromJSON(object: any): Receipt {
    return {
      receiptMethod: isSet(object.receiptMethod) ? salesOrder_ReceiptMethodFromJSON(object.receiptMethod) : 0,
      taxId: isSet(object.taxId) ? String(object.taxId) : "",
      donateUnitId: isSet(object.donateUnitId) ? String(object.donateUnitId) : "",
      mobileBarcode: isSet(object.mobileBarcode) ? String(object.mobileBarcode) : "",
      recipientName: isSet(object.recipientName) ? String(object.recipientName) : "",
      recipientPostcode: isSet(object.recipientPostcode) ? String(object.recipientPostcode) : "",
      recipientCity: isSet(object.recipientCity) ? String(object.recipientCity) : "",
      recipientArea: isSet(object.recipientArea) ? String(object.recipientArea) : "",
      recipientStreet: isSet(object.recipientStreet) ? String(object.recipientStreet) : "",
    };
  },

  toJSON(message: Receipt): unknown {
    const obj: any = {};
    message.receiptMethod !== undefined && (obj.receiptMethod = salesOrder_ReceiptMethodToJSON(message.receiptMethod));
    message.taxId !== undefined && (obj.taxId = message.taxId);
    message.donateUnitId !== undefined && (obj.donateUnitId = message.donateUnitId);
    message.mobileBarcode !== undefined && (obj.mobileBarcode = message.mobileBarcode);
    message.recipientName !== undefined && (obj.recipientName = message.recipientName);
    message.recipientPostcode !== undefined && (obj.recipientPostcode = message.recipientPostcode);
    message.recipientCity !== undefined && (obj.recipientCity = message.recipientCity);
    message.recipientArea !== undefined && (obj.recipientArea = message.recipientArea);
    message.recipientStreet !== undefined && (obj.recipientStreet = message.recipientStreet);
    return obj;
  },

  create<I extends Exact<DeepPartial<Receipt>, I>>(base?: I): Receipt {
    return Receipt.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Receipt>, I>>(object: I): Receipt {
    const message = createBaseReceipt();
    message.receiptMethod = object.receiptMethod ?? 0;
    message.taxId = object.taxId ?? "";
    message.donateUnitId = object.donateUnitId ?? "";
    message.mobileBarcode = object.mobileBarcode ?? "";
    message.recipientName = object.recipientName ?? "";
    message.recipientPostcode = object.recipientPostcode ?? "";
    message.recipientCity = object.recipientCity ?? "";
    message.recipientArea = object.recipientArea ?? "";
    message.recipientStreet = object.recipientStreet ?? "";
    return message;
  },
};

function createBaseReceipt_DonationUnit(): Receipt_DonationUnit {
  return { id: "", name: "" };
}

export const Receipt_DonationUnit = {
  fromJSON(object: any): Receipt_DonationUnit {
    return { id: isSet(object.id) ? String(object.id) : "", name: isSet(object.name) ? String(object.name) : "" };
  },

  toJSON(message: Receipt_DonationUnit): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.name !== undefined && (obj.name = message.name);
    return obj;
  },

  create<I extends Exact<DeepPartial<Receipt_DonationUnit>, I>>(base?: I): Receipt_DonationUnit {
    return Receipt_DonationUnit.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Receipt_DonationUnit>, I>>(object: I): Receipt_DonationUnit {
    const message = createBaseReceipt_DonationUnit();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseRating(): Rating {
  return {
    itemId: "",
    orderId: "",
    productId: "",
    skuId: "",
    createTime: undefined,
    content: "",
    hide: false,
    reply: "",
    replyTime: undefined,
  };
}

export const Rating = {
  fromJSON(object: any): Rating {
    return {
      itemId: isSet(object.itemId) ? String(object.itemId) : "",
      orderId: isSet(object.orderId) ? String(object.orderId) : "",
      productId: isSet(object.productId) ? String(object.productId) : "",
      skuId: isSet(object.skuId) ? String(object.skuId) : "",
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      content: isSet(object.content) ? String(object.content) : "",
      hide: isSet(object.hide) ? Boolean(object.hide) : false,
      reply: isSet(object.reply) ? String(object.reply) : "",
      replyTime: isSet(object.replyTime) ? fromJsonTimestamp(object.replyTime) : undefined,
    };
  },

  toJSON(message: Rating): unknown {
    const obj: any = {};
    message.itemId !== undefined && (obj.itemId = message.itemId);
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.productId !== undefined && (obj.productId = message.productId);
    message.skuId !== undefined && (obj.skuId = message.skuId);
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.content !== undefined && (obj.content = message.content);
    message.hide !== undefined && (obj.hide = message.hide);
    message.reply !== undefined && (obj.reply = message.reply);
    message.replyTime !== undefined && (obj.replyTime = message.replyTime.toISOString());
    return obj;
  },

  create<I extends Exact<DeepPartial<Rating>, I>>(base?: I): Rating {
    return Rating.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Rating>, I>>(object: I): Rating {
    const message = createBaseRating();
    message.itemId = object.itemId ?? "";
    message.orderId = object.orderId ?? "";
    message.productId = object.productId ?? "";
    message.skuId = object.skuId ?? "";
    message.createTime = object.createTime ?? undefined;
    message.content = object.content ?? "";
    message.hide = object.hide ?? false;
    message.reply = object.reply ?? "";
    message.replyTime = object.replyTime ?? undefined;
    return message;
  },
};

function createBasePayment(): Payment {
  return {
    id: "",
    orderSourceId: "",
    externalAppId: "",
    paymentType: 0,
    platform: 0,
    totalAmount: "",
    state: 0,
    createTime: undefined,
    externalId: "",
    authorizationCode: "",
    reqTime: undefined,
    respTime: undefined,
    creditCardType: 0,
    highRisk: false,
    secureVerification: false,
  };
}

export const Payment = {
  fromJSON(object: any): Payment {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      orderSourceId: isSet(object.orderSourceId) ? String(object.orderSourceId) : "",
      externalAppId: isSet(object.externalAppId) ? String(object.externalAppId) : "",
      paymentType: isSet(object.paymentType) ? salesOrder_PaymentTypeFromJSON(object.paymentType) : 0,
      platform: isSet(object.platform) ? app_PlatformFromJSON(object.platform) : 0,
      totalAmount: isSet(object.totalAmount) ? String(object.totalAmount) : "",
      state: isSet(object.state) ? Number(object.state) : 0,
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      externalId: isSet(object.externalId) ? String(object.externalId) : "",
      authorizationCode: isSet(object.authorizationCode) ? String(object.authorizationCode) : "",
      reqTime: isSet(object.reqTime) ? fromJsonTimestamp(object.reqTime) : undefined,
      respTime: isSet(object.respTime) ? fromJsonTimestamp(object.respTime) : undefined,
      creditCardType: isSet(object.creditCardType) ? Number(object.creditCardType) : 0,
      highRisk: isSet(object.highRisk) ? Boolean(object.highRisk) : false,
      secureVerification: isSet(object.secureVerification) ? Boolean(object.secureVerification) : false,
    };
  },

  toJSON(message: Payment): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.orderSourceId !== undefined && (obj.orderSourceId = message.orderSourceId);
    message.externalAppId !== undefined && (obj.externalAppId = message.externalAppId);
    message.paymentType !== undefined && (obj.paymentType = salesOrder_PaymentTypeToJSON(message.paymentType));
    message.platform !== undefined && (obj.platform = app_PlatformToJSON(message.platform));
    message.totalAmount !== undefined && (obj.totalAmount = message.totalAmount);
    message.state !== undefined && (obj.state = Math.round(message.state));
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.externalId !== undefined && (obj.externalId = message.externalId);
    message.authorizationCode !== undefined && (obj.authorizationCode = message.authorizationCode);
    message.reqTime !== undefined && (obj.reqTime = message.reqTime.toISOString());
    message.respTime !== undefined && (obj.respTime = message.respTime.toISOString());
    message.creditCardType !== undefined && (obj.creditCardType = Math.round(message.creditCardType));
    message.highRisk !== undefined && (obj.highRisk = message.highRisk);
    message.secureVerification !== undefined && (obj.secureVerification = message.secureVerification);
    return obj;
  },

  create<I extends Exact<DeepPartial<Payment>, I>>(base?: I): Payment {
    return Payment.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Payment>, I>>(object: I): Payment {
    const message = createBasePayment();
    message.id = object.id ?? "";
    message.orderSourceId = object.orderSourceId ?? "";
    message.externalAppId = object.externalAppId ?? "";
    message.paymentType = object.paymentType ?? 0;
    message.platform = object.platform ?? 0;
    message.totalAmount = object.totalAmount ?? "";
    message.state = object.state ?? 0;
    message.createTime = object.createTime ?? undefined;
    message.externalId = object.externalId ?? "";
    message.authorizationCode = object.authorizationCode ?? "";
    message.reqTime = object.reqTime ?? undefined;
    message.respTime = object.respTime ?? undefined;
    message.creditCardType = object.creditCardType ?? 0;
    message.highRisk = object.highRisk ?? false;
    message.secureVerification = object.secureVerification ?? false;
    return message;
  },
};

function createBaseEInvoice(): EInvoice {
  return {
    number: "",
    orderSourceId: "",
    uniform: 0,
    invoiceDate: undefined,
    issuedTime: undefined,
    randomCode: "",
    taxRegistrationNo: "",
    barcode: "",
    leftQrcode: "",
    rightQrcode: "",
    memo: "",
    items: [],
    shippingFee: "",
    compensationAmount: "",
    totalAmount: "",
  };
}

export const EInvoice = {
  fromJSON(object: any): EInvoice {
    return {
      number: isSet(object.number) ? String(object.number) : "",
      orderSourceId: isSet(object.orderSourceId) ? String(object.orderSourceId) : "",
      uniform: isSet(object.uniform) ? invoiceUniformFromJSON(object.uniform) : 0,
      invoiceDate: isSet(object.invoiceDate) ? fromJsonTimestamp(object.invoiceDate) : undefined,
      issuedTime: isSet(object.issuedTime) ? fromJsonTimestamp(object.issuedTime) : undefined,
      randomCode: isSet(object.randomCode) ? String(object.randomCode) : "",
      taxRegistrationNo: isSet(object.taxRegistrationNo) ? String(object.taxRegistrationNo) : "",
      barcode: isSet(object.barcode) ? String(object.barcode) : "",
      leftQrcode: isSet(object.leftQrcode) ? String(object.leftQrcode) : "",
      rightQrcode: isSet(object.rightQrcode) ? String(object.rightQrcode) : "",
      memo: isSet(object.memo) ? String(object.memo) : "",
      items: Array.isArray(object?.items) ? object.items.map((e: any) => EInvoice_Item.fromJSON(e)) : [],
      shippingFee: isSet(object.shippingFee) ? String(object.shippingFee) : "",
      compensationAmount: isSet(object.compensationAmount) ? String(object.compensationAmount) : "",
      totalAmount: isSet(object.totalAmount) ? String(object.totalAmount) : "",
    };
  },

  toJSON(message: EInvoice): unknown {
    const obj: any = {};
    message.number !== undefined && (obj.number = message.number);
    message.orderSourceId !== undefined && (obj.orderSourceId = message.orderSourceId);
    message.uniform !== undefined && (obj.uniform = invoiceUniformToJSON(message.uniform));
    message.invoiceDate !== undefined && (obj.invoiceDate = message.invoiceDate.toISOString());
    message.issuedTime !== undefined && (obj.issuedTime = message.issuedTime.toISOString());
    message.randomCode !== undefined && (obj.randomCode = message.randomCode);
    message.taxRegistrationNo !== undefined && (obj.taxRegistrationNo = message.taxRegistrationNo);
    message.barcode !== undefined && (obj.barcode = message.barcode);
    message.leftQrcode !== undefined && (obj.leftQrcode = message.leftQrcode);
    message.rightQrcode !== undefined && (obj.rightQrcode = message.rightQrcode);
    message.memo !== undefined && (obj.memo = message.memo);
    if (message.items) {
      obj.items = message.items.map((e) => e ? EInvoice_Item.toJSON(e) : undefined);
    } else {
      obj.items = [];
    }
    message.shippingFee !== undefined && (obj.shippingFee = message.shippingFee);
    message.compensationAmount !== undefined && (obj.compensationAmount = message.compensationAmount);
    message.totalAmount !== undefined && (obj.totalAmount = message.totalAmount);
    return obj;
  },

  create<I extends Exact<DeepPartial<EInvoice>, I>>(base?: I): EInvoice {
    return EInvoice.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<EInvoice>, I>>(object: I): EInvoice {
    const message = createBaseEInvoice();
    message.number = object.number ?? "";
    message.orderSourceId = object.orderSourceId ?? "";
    message.uniform = object.uniform ?? 0;
    message.invoiceDate = object.invoiceDate ?? undefined;
    message.issuedTime = object.issuedTime ?? undefined;
    message.randomCode = object.randomCode ?? "";
    message.taxRegistrationNo = object.taxRegistrationNo ?? "";
    message.barcode = object.barcode ?? "";
    message.leftQrcode = object.leftQrcode ?? "";
    message.rightQrcode = object.rightQrcode ?? "";
    message.memo = object.memo ?? "";
    message.items = object.items?.map((e) => EInvoice_Item.fromPartial(e)) || [];
    message.shippingFee = object.shippingFee ?? "";
    message.compensationAmount = object.compensationAmount ?? "";
    message.totalAmount = object.totalAmount ?? "";
    return message;
  },
};

function createBaseEInvoice_Item(): EInvoice_Item {
  return { name: "", totalAmount: "", itemId: "" };
}

export const EInvoice_Item = {
  fromJSON(object: any): EInvoice_Item {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      totalAmount: isSet(object.totalAmount) ? String(object.totalAmount) : "",
      itemId: isSet(object.itemId) ? String(object.itemId) : "",
    };
  },

  toJSON(message: EInvoice_Item): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.totalAmount !== undefined && (obj.totalAmount = message.totalAmount);
    message.itemId !== undefined && (obj.itemId = message.itemId);
    return obj;
  },

  create<I extends Exact<DeepPartial<EInvoice_Item>, I>>(base?: I): EInvoice_Item {
    return EInvoice_Item.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<EInvoice_Item>, I>>(object: I): EInvoice_Item {
    const message = createBaseEInvoice_Item();
    message.name = object.name ?? "";
    message.totalAmount = object.totalAmount ?? "";
    message.itemId = object.itemId ?? "";
    return message;
  },
};

function createBaseSalesAllowance(): SalesAllowance {
  return {
    number: "",
    date: undefined,
    amount: "",
    amountBeforeTax: "",
    taxAmount: "",
    shippingFee: "",
    compensationAmount: "",
    items: [],
  };
}

export const SalesAllowance = {
  fromJSON(object: any): SalesAllowance {
    return {
      number: isSet(object.number) ? String(object.number) : "",
      date: isSet(object.date) ? fromJsonTimestamp(object.date) : undefined,
      amount: isSet(object.amount) ? String(object.amount) : "",
      amountBeforeTax: isSet(object.amountBeforeTax) ? String(object.amountBeforeTax) : "",
      taxAmount: isSet(object.taxAmount) ? String(object.taxAmount) : "",
      shippingFee: isSet(object.shippingFee) ? String(object.shippingFee) : "",
      compensationAmount: isSet(object.compensationAmount) ? String(object.compensationAmount) : "",
      items: Array.isArray(object?.items) ? object.items.map((e: any) => SalesAllowance_Item.fromJSON(e)) : [],
    };
  },

  toJSON(message: SalesAllowance): unknown {
    const obj: any = {};
    message.number !== undefined && (obj.number = message.number);
    message.date !== undefined && (obj.date = message.date.toISOString());
    message.amount !== undefined && (obj.amount = message.amount);
    message.amountBeforeTax !== undefined && (obj.amountBeforeTax = message.amountBeforeTax);
    message.taxAmount !== undefined && (obj.taxAmount = message.taxAmount);
    message.shippingFee !== undefined && (obj.shippingFee = message.shippingFee);
    message.compensationAmount !== undefined && (obj.compensationAmount = message.compensationAmount);
    if (message.items) {
      obj.items = message.items.map((e) => e ? SalesAllowance_Item.toJSON(e) : undefined);
    } else {
      obj.items = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesAllowance>, I>>(base?: I): SalesAllowance {
    return SalesAllowance.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesAllowance>, I>>(object: I): SalesAllowance {
    const message = createBaseSalesAllowance();
    message.number = object.number ?? "";
    message.date = object.date ?? undefined;
    message.amount = object.amount ?? "";
    message.amountBeforeTax = object.amountBeforeTax ?? "";
    message.taxAmount = object.taxAmount ?? "";
    message.shippingFee = object.shippingFee ?? "";
    message.compensationAmount = object.compensationAmount ?? "";
    message.items = object.items?.map((e) => SalesAllowance_Item.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSalesAllowance_Item(): SalesAllowance_Item {
  return { name: "", quantity: 0, unitPrice: "", itemId: "" };
}

export const SalesAllowance_Item = {
  fromJSON(object: any): SalesAllowance_Item {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      quantity: isSet(object.quantity) ? Number(object.quantity) : 0,
      unitPrice: isSet(object.unitPrice) ? String(object.unitPrice) : "",
      itemId: isSet(object.itemId) ? String(object.itemId) : "",
    };
  },

  toJSON(message: SalesAllowance_Item): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.quantity !== undefined && (obj.quantity = Math.round(message.quantity));
    message.unitPrice !== undefined && (obj.unitPrice = message.unitPrice);
    message.itemId !== undefined && (obj.itemId = message.itemId);
    return obj;
  },

  create<I extends Exact<DeepPartial<SalesAllowance_Item>, I>>(base?: I): SalesAllowance_Item {
    return SalesAllowance_Item.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SalesAllowance_Item>, I>>(object: I): SalesAllowance_Item {
    const message = createBaseSalesAllowance_Item();
    message.name = object.name ?? "";
    message.quantity = object.quantity ?? 0;
    message.unitPrice = object.unitPrice ?? "";
    message.itemId = object.itemId ?? "";
    return message;
  },
};

function createBaseTrackingNumber(): TrackingNumber {
  return {
    id: "",
    type: 0,
    name: "",
    createTime: undefined,
    startNumber: "",
    endNumber: "",
    quantity: 0,
    usageQuantity: 0,
  };
}

export const TrackingNumber = {
  fromJSON(object: any): TrackingNumber {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      type: isSet(object.type) ? trackingNumber_TypeFromJSON(object.type) : 0,
      name: isSet(object.name) ? String(object.name) : "",
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      startNumber: isSet(object.startNumber) ? String(object.startNumber) : "",
      endNumber: isSet(object.endNumber) ? String(object.endNumber) : "",
      quantity: isSet(object.quantity) ? Number(object.quantity) : 0,
      usageQuantity: isSet(object.usageQuantity) ? Number(object.usageQuantity) : 0,
    };
  },

  toJSON(message: TrackingNumber): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.type !== undefined && (obj.type = trackingNumber_TypeToJSON(message.type));
    message.name !== undefined && (obj.name = message.name);
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.startNumber !== undefined && (obj.startNumber = message.startNumber);
    message.endNumber !== undefined && (obj.endNumber = message.endNumber);
    message.quantity !== undefined && (obj.quantity = Math.round(message.quantity));
    message.usageQuantity !== undefined && (obj.usageQuantity = Math.round(message.usageQuantity));
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackingNumber>, I>>(base?: I): TrackingNumber {
    return TrackingNumber.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<TrackingNumber>, I>>(object: I): TrackingNumber {
    const message = createBaseTrackingNumber();
    message.id = object.id ?? "";
    message.type = object.type ?? 0;
    message.name = object.name ?? "";
    message.createTime = object.createTime ?? undefined;
    message.startNumber = object.startNumber ?? "";
    message.endNumber = object.endNumber ?? "";
    message.quantity = object.quantity ?? 0;
    message.usageQuantity = object.usageQuantity ?? 0;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
